import { z } from "zod";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

/** The invoice a reminder is linked to by hand, or null to take a wrong link back. */
export const incomingInvoiceReminderLinkSchema = z.object({
	incomingInvoiceId: ZodStringNullable,
});

export type IncomingInvoiceReminderLinkSchema = z.infer<typeof incomingInvoiceReminderLinkSchema>;
